module.exports = __webpack_public_path__ + "static/media/performance-trophy.c4c8aba4.svg";